import getConfig from 'next/config';

const config = getConfig() || {};

// On the server, we want any public config to also be available.
// For this reason we merge the two in this order.
export default {
  ...config.publicRuntimeConfig,
  ...config.serverRuntimeConfig,
};
